import axios from '../http'

function query(data) {
    return axios.post('/event/withDrawal/query', data);
}

function get(id) {
    return axios.get('/event/withDrawal/get?id=' + id);
}

function substitute(data) {
    return axios.post('/event/withDrawal/substitute', data);
}

export default {
    query,
    get,
    substitute
}